import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", {
  class: "text-big",
  id: "org-name-label"
}, "What should the name of the new Organisation be?", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-warning" }, "Note:"),
  /*#__PURE__*/_createTextVNode(" it must be unique across the Gyre platform.")
], -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = {
  key: 0,
  class: "text-danger text-left"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = ["disabled"]

import { computed, reactive, ref } from "vue";
import axios from "axios";
import { Modal } from "uiv";
import { useVuelidate } from "@vuelidate/core";
import { required, maxLength, helpers } from "@vuelidate/validators";
import organisationNameRegex from "../../../services/utilities/organisation-name-regex";
import {
  OrganisationAndMembersApiModel,
  OrganisationDescriptionApiModel,
} from "../../../api-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'create-organisation-dialog',
  setup(__props, { expose: __expose }) {

const resolveCallback = ref<((value: OrganisationAndMembersApiModel | null) => void) | null>(null);
const rejectCallback = ref<((reason?: any) => void) | null>(null);
const errors = ref<string[]>([]);
const allOrganisations = ref<OrganisationDescriptionApiModel[] | null>(null);
const name = ref("");
const shown = ref(false);

const orgNameRegex = helpers.regex(organisationNameRegex);

const rules = computed(() => ({
  name: {
    required,
    maxLength: maxLength(40),
    regex: (value: string) => orgNameRegex(value),
  },
}));

const state = reactive({ name });

const v$ = useVuelidate(rules, state, { $autoDirty: true });

const close = () => {
  v$.value.$reset();
  shown.value = false;
};

const cancel = () => {
  close();
  if (resolveCallback.value) {
    resolveCallback.value(null);
  }
};

const open = (
  allOrganisationsParam: OrganisationDescriptionApiModel[],
): Promise<OrganisationAndMembersApiModel | null> => {
  allOrganisations.value = allOrganisationsParam;
  name.value = "";
  errors.value = [];
  shown.value = true;
  return new Promise<OrganisationAndMembersApiModel | null>((resolve, reject) => {
    resolveCallback.value = resolve;
    rejectCallback.value = reject;
  });
};

const createOrganisation = () => {
  v$.value.$touch();
  const isValid = !v$.value.$invalid;

  if (!isValid) {
    return;
  }

  axios
    .post("/api/organisation/", JSON.stringify(name.value), {
      headers: { "content-type": "application/json" },
      validateStatus(status) {
        return status === 200 || status === 409; // Conflict
      },
    })
    .then((res) => {
      if (res.status === 200) {
        errors.value = [];
        close();
        const newOrganisationModel = res.data as OrganisationAndMembersApiModel;
        if (resolveCallback.value) {
          resolveCallback.value(newOrganisationModel);
        }
      } else {
        errors.value = ["That name is already taken, please choose another one."];
      }
    })
    .catch(() => {
      errors.value = ["There was a problem creating the organisation, please try again."];
    });
};

__expose({ open, close });

return (_ctx: any,_cache: any) => {
  return (allOrganisations.value)
    ? (_openBlock(), _createBlock(_unref(Modal), {
        key: 0,
        class: "organisation-group-removal-dialog text-left",
        modelValue: shown.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((shown).value = $event)),
        title: "Create new organisation"
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              class: "btn btn-primary btn-lg",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (createOrganisation())),
              disabled: !name.value || _unref(v$).name.$invalid,
              type: "button"
            }, " Create ", 8, _hoisted_9),
            _createElementVNode("button", {
              class: "btn btn-default btn-lg",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (cancel())),
              type: "button"
            }, "Cancel")
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(["col-sm-12 text-big", { 'has-error': _unref(v$).name.$error }])
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                  onBlur: _cache[1] || (_cache[1] = ($event: any) => (_unref(v$).name.$touch())),
                  maxlength: "40",
                  "aria-labelledby": "org-name-label"
                }, null, 544), [
                  [_vModelText, name.value]
                ])
              ], 2)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (error) => {
              return (_openBlock(), _createElementBlock("p", {
                class: "text-danger text-left",
                key: error
              }, _toDisplayString(error), 1))
            }), 128)),
            (_unref(v$).name.$error)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                  (_unref(v$).name.required.$invalid)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Name is required."))
                    : _createCommentVNode("", true),
                  (_unref(v$).name.maxLength.$invalid)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Name must be at most 40 characters."))
                    : _createCommentVNode("", true),
                  (_unref(v$).name.regex.$invalid)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Name does not match the required format."))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})